import { gql } from "__generated__"

export const FETCH_ATTENDANCES = gql(`
  query FetchAttendances($startDate: String, $endDate: String, $attendeeIds: [Float!]) {
    attendances(startDate: $startDate, endDate: $endDate, attendeeIds: $attendeeIds) {
      id
      date
      actionTime
      action
      attendee {
        id
        name
        discordName
        discordId
        isPartTime
      }
    }
  }
`)
